import * as yup from "yup";

export const ChooseLocationSchema = yup.object({
  location: yup.string().required(),
  address: yup.string().nullable(),
  locationId: yup.string().nullable(),
});

export const ChooseLocationOnboardingFormSchema = yup.object({
  location: yup.string().required(),
  locationId: yup.string().nullable(),
  placeId: yup.string().nullable(),
  streetAddress: yup.string().required("Street Address is required"),
  address: yup.string().required("Address is required"),
  townCity: yup.string().required("Town/City is required"),
  zipCode: yup
    .string()
    .required("Zip code is required")
    .matches(/^\d{5}(-\d{4})?$/, "Invalid zip code"),
  country: yup.string().nullable(),

});

export type ChooseLocationFormType = yup.InferType<typeof ChooseLocationSchema>;
export type ChooseLocationOnboardingFormType = yup.InferType<typeof ChooseLocationOnboardingFormSchema>;
